/*
 * Copyright (c) 2026. Bluemate B.V.
 */

import {RefObject, useLayoutEffect} from 'react';
import {useLocation} from 'react-router';

export function useResetScrollOnNavigate(ref: RefObject<HTMLElement | null>): void {
    const {pathname} = useLocation();

    useLayoutEffect(() => {
        const element = ref.current;
        if (element) element.scrollTop = 0;
    }, [ref, pathname]);
}
